// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SystemUpdate: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<polygon points="14.78,2.42 14.78,3.82 21.32,3.82 21.32,22.45 2.68,22.45 2.68,3.82 9.22,3.82 9.22,2.42 1.28,2.42 1.28,23.85 
	22.72,23.85 22.72,2.42 "/>
<polygon points="8.58,8.85 11.86,12.14 15.15,8.85 14.16,7.86 12.56,9.46 12.56,0.15 11.16,0.15 11.16,9.46 9.57,7.86 "/>
</svg>;
};

export default React.memo(SystemUpdate);
